import { QueryHookOptions } from '@apollo/client'
import B2C_GET_ORDER_BY_ID from '@graphql/queries/getOrderById.query'
import { B2CGetOrderByIdQuery, B2CGetOrderByIdQueryVariables } from 'parkdepot-shared/gql/graphql'
import { useAuthenticatedQuery } from './useAuth'

const useGetOrderById = (opts: QueryHookOptions<B2CGetOrderByIdQuery, B2CGetOrderByIdQueryVariables>) => {
    return useAuthenticatedQuery({ query: B2C_GET_ORDER_BY_ID, ...opts })
}

export default useGetOrderById
